// Export the Component Definition for use in Contentful Studio
export {UnitCardContentfulComponentDefinition} from './UnitCardContentfulDefinition';
export type {UnitCardProps, UnitTitleColor} from './UnitCard';
export {unitTitleColorCss} from './UnitCard';
export {default} from './UnitCard';
